import React from "react";
import ReactDOM from "react-dom";
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ListeningGuide from "./Components/ListeningGuide/ListeningGuide"
import HomePage from "./Pages/HomePage/HomePage";

// const importAll = (r) => {
//   return r.keys().map(r);
// };

const location = new URL(document.location)

const importDirectories = (r) => {
  const directory = r.keys().map(key => (
    {
      "path": key.replace("./", "").replace(".json", ""),
      "module": r(key)
    }
  ))
  return directory
}

// console.log(process.env.PUBLIC_URL)

// import all json files from Data folder as an array
// const dataFiles = importAll(require.context("./Data", true, /\.json$/));

const directories = importDirectories(require.context("./Data", true, /\.json$/))

// setting up browser routes
const browserRoutes = createBrowserRouter([
  // custom error message, currently blank
  {
    path: `*`,
    element: <div></div>,
  },
  // all other routes
  // ...dataFiles.map((element) => ({
  //   path: `/v2/enjmusic5ess/${element.title}/interact`,
  //   element: <App Data={element} />,
  // })),

  // new browser routes
  ...directories.map((element) => ({
    path: `${element.path}`,
    // element: <App Data={element.module} />
    element: <ListeningGuide Data={element.module} videoTrack={"https://d1nsvqb2cv5fq6.cloudfront.net/biology/bionow4e/trailer/ch02_trailer.mp4"} />
  }))
]);

// setting up hash routes for testing
const hashRoutes = createHashRouter([
  // custom error message, currently blank
  {
    basename: process.env.PUBLIC_URL,
    path: `*`,
    element: <div></div>,
  },
  // all other routes
  // ...dataFiles.map((element) => ({
  //   path: `${element.title}`,
  //   element: <App Data={element} />,
  // })),
  {
    basename: process.env.PUBLIC_URL,
    path: `catalog`,
    element: location?.origin === "http://localhost:3000" || location?.origin === "https://video-interactive-listening-guides-wwnorton-medi-bdc68b78faed43.gitlab.io" ? <HomePage directories={directories} /> : <div></div>,
  },
  // new browser routes
  ...directories.map((element) => ({
    path: `${element.path}`,
    // element: <App Data={element.module} />
    element: <ListeningGuide Data={element.module} videoTrack={"https://d1nsvqb2cv5fq6.cloudfront.net/biology/bionow4e/trailer/ch02_trailer.mp4"} />
  }))
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={browserRoutes} />
    <RouterProvider router={hashRoutes} />
    {/* <App /> */}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
